export default __webpack_public_path__ + "static/media/TheWorldEngland_03.2550538d.png";